import {
  Box,
  Paper,
  ListItem,
  styled
} from '@mui/material';

// Estilos para itens de partida
export const MatchItem = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(0.5),
  borderRadius: theme.spacing(1),
  cursor: 'pointer',
  transition: '0.2s',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : theme.palette.action.hover,
  },
}));

export const SelectedMatchItem = styled(MatchItem)(({ theme }) => ({
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.mode === 'dark'
    ? 'rgba(30, 30, 40, 0.6)'
    : 'rgba(42, 244, 151, 0.03)',
}));

export const LiveMatchItem = styled(MatchItem)(({ theme }) => ({
  borderLeft: `4px solid ${theme.palette.success.main}`,
}));

// Estilo para itens de liga
export const LeagueItem = styled(ListItem)<{ selected?: boolean }>(({ theme, selected }) => ({
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
  backgroundColor: selected ? theme.palette.action.selected : 'inherit',
  cursor: 'pointer',
  transition: '0.2s',
  '&:hover': {
    backgroundColor: selected 
      ? theme.palette.action.selected 
      : theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : theme.palette.action.hover,
  },
}));

// Estilo para o card de detalhes da partida
export const MatchDetailCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  height: '100%',
  overflowY: 'auto',
}));

// Container da lista de partidas
export const MatchListContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: 'calc(100vh - 240px)',
  overflowY: 'auto',
  position: 'relative',
}));

// Container de navegação de datas
export const DateNavContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  marginBottom: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

// Container de odds
export const OddsButton = styled(Box)(({ theme }) => ({
  minWidth: 80,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0.5),
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    cursor: 'pointer',
  },
}));

// Container do cabeçalho da liga
export const LeagueHeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.mode === 'dark'
    ? 'rgba(30, 30, 40, 0.7)'
    : theme.palette.background.paper,
}));

// Container principal
export const MainContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}));